import React from 'react';

import {
  AdUnitsOutlined,
  BlockOutlined,
  CabinOutlined,
  DirectionsBoatOutlined,
  EventNoteOutlined,
  FormatListNumberedOutlined,
  GroupOutlined,
  HouseboatOutlined,
  LocalOfferOutlined,
  ManageSearchOutlined,
  ReorderOutlined,
  RuleFolderOutlined,
  SailingOutlined,
  TsunamiOutlined,
  ViewCarouselOutlined,
} from '@mui/icons-material';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { Box, SxProps } from '@mui/material';

import SidebarSection, { SidebarSectionProps } from '~/components/Opportunity/OpportunitySidebar/SidebarSection';
import { HEADER_HEIGHT } from '~/components/layouts/Layout';

const SIDEBAR_STYLE: SxProps = {
  borderColor: 'divider',
  position: { xs: 'static', md: 'sticky' },
  top: { md: 0 },
  alignSelf: { md: 'flex-start' },
  maxHeight: { md: `calc(100vh - ${HEADER_HEIGHT}px)` },
  overflowY: { md: 'auto' },
};

export default function CruisesSidebar() {
  const sections: Array<SidebarSectionProps> = [
    {
      title: 'Offers',
      items: [
        {
          label: 'Flash Offers',
          icon: <StarOutlineIcon />,
          url: `/tours/lists/le`,
        },
        {
          label: 'Cruisebank Offers',
          icon: <TsunamiOutlined />,
          url: `/cruises/offers`,
        },
        {
          label: 'Cruisebank Sailings',
          icon: <SailingOutlined />,
          url: `/cruises/sailings`,
        },
        {
          label: 'Check Invalid Offers',
          icon: <BlockOutlined />,
          url: `/cruises/invalid-offers`,
        },
      ],
    },
    {
      title: 'Cruise CMS',
      items: [
        {
          label: 'Cruise Lines',
          icon: <HouseboatOutlined />,
          url: `/cruises/cruise-lines`,
        },
        {
          label: 'Ships',
          icon: <DirectionsBoatOutlined />,
          url: `/cruises/ships`,
        },
        {
          label: 'Cabin Categories',
          icon: <CabinOutlined />,
          url: `/cruises/cabin-categories`,
        },
        {
          label: 'Cabin Categories Groups',
          icon: <GroupOutlined />,
          url: `/cruises/cabin-categories-groups`,
        },
        {
          label: 'Ports',
          icon: <EventNoteOutlined />,
          url: `/cruises/ports`,
        },
      ],
    },
    {
      title: 'Rates & Promos',
      items: [
        {
          label: 'Rate Code Management',
          icon: <ManageSearchOutlined />,
          url: `/cruises/rate-code-management`,
        },
        {
          label: 'Rate Code Creation',
          icon: <ReorderOutlined />,
          url: `/cruises/rate-code-creation`,
        },
        {
          label: 'Rate Grouping',
          icon: <RuleFolderOutlined />,
          url: `/cruises/rate-grouping`,
        },
        {
          label: 'Promo Banners',
          icon: <AdUnitsOutlined />,
          url: `/cruises/promo-banners`,
        },
        {
          label: 'Inclusions',
          icon: <ViewCarouselOutlined />,
          url: `/cruises/inclusions`,
        },
        {
          label: 'Bundles',
          icon: <ViewCarouselOutlined />,
          url: `/cruises/bundles`,
        },
        {
          label: 'Deals',
          icon: <LocalOfferOutlined />,
          url: `/cruises/deals`,
        },
        {
          label: 'Deal Page Ordering',
          icon: <FormatListNumberedOutlined />,
          url: `/cruises/deals/ordering`,
        },
      ],
    },
    {
      title: 'Bookings',
      items: [
        {
          label: 'Logs',
          icon: <FormatListNumberedOutlined />,
          url: `/cruises/booking-logs`,
        },
      ],
    },
  ];

  return (
    <Box sx={SIDEBAR_STYLE}>
      {sections.map((section, index) => (
        <SidebarSection key={`${section.title}-${index}`} {...section} />
      ))}
    </Box>
  );
}
